module.exports = __webpack_public_path__ + "img/menu10.a1e67f8a.png";